import { InjectionToken } from '@angular/core';

export interface IhmConfiguration {
  apiEndpoint: string;
  oktaConfig?: any;
}

export const IHM_CONFIG_NAME = new InjectionToken<string>('IHM_CONFIG_NAME');
export const IHM_CONFIG = new InjectionToken<IhmConfiguration>('IHM_CONFIG');
